import { render, staticRenderFns } from "./CategoryItemList.vue?vue&type=template&id=37f6bdfa&"
import script from "./CategoryItemList.vue?vue&type=script&lang=js&"
export * from "./CategoryItemList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItemList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports